"use strict";
import "bootstrap";
import nav from "./nav"
import "slick-carousel"
import carousel from "./carousel";
import "readmore-js";
import readmore from './readmore';

nav();
carousel();
readmore();